const RESETS = `
  /* http://meyerweb.com/eric/tools/css/reset/
   * v2.0 | 20110126
   * License: none (public domain)
   */
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
`

const FONTS = `
@font-face {
  font-family: 'Helvetica Now Display';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local('HelveticaNowDisplay Bold'), local('HelveticaNowDisplay-Bold'),
    url(https://assets.creditas.com/design-system-assets/fonts/helvetica-now-display/HelveticaNowDisplay-Bold.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: 'Helvetica Now Display';
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local('HelveticaNowDisplay Light'), local('HelveticaNowDisplay-Light'),
    url(https://assets.creditas.com/design-system-assets/fonts/helvetica-now-display/HelveticaNowDisplay-Light.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: 'Helvetica Now Display';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: local('HelveticaNowDisplay Medium'), local('HelveticaNowDisplay-Medium'),
    url(https://assets.creditas.com/design-system-assets/fonts/helvetica-now-display/HelveticaNowDisplay-Medium.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: 'Helvetica Now Display';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local('HelveticaNowDisplay Regular'), local('HelveticaNowDisplay-Regular'),
    url(https://assets.creditas.com/design-system-assets/fonts/helvetica-now-display/HelveticaNowDisplay-Regular.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
    U+2215, U+FEFF, U+FFFD;
}
`

export { RESETS, FONTS }
